import {
  setFilterPickupDate,
  setFilterReturnDate,
  setFilterPickupTime,
  setFilterReturnTime,
  setFilterDate,
} from "core/store/slices/settingSlice";
import store from "core/store/store";
import dayjs from "dayjs";

export interface FilterDates {
  pickupDate?: Date | string;
  pickupTime?: string;
  returnDate?: Date | string;
  returnTime?: string;
};

export const stringifyFilterDate = (date: Date | string) => typeof date === 'string' ? date : dayjs(date).format('MM/DD/YYYY');

export const dayjsifyFilterDate = (date: Date | string) => date instanceof Date ? dayjs(date) : dayjs(date, 'MM/DD/YYYY');

export const isPickupAfterReturn = (
  pickupDate: Date | string,
  returnDate: Date | string,
) => dayjsifyFilterDate(pickupDate).isAfter(dayjsifyFilterDate(returnDate).endOf('day'))

export const isDateBeforeToday = (
  pickupDate: Date | string,
) => dayjsifyFilterDate(pickupDate).endOf('day').isBefore(dayjs().startOf('day'))

export const setPickupDate = (pickupDate: FilterDates['pickupDate']) => {
  if (!pickupDate || isDateBeforeToday(pickupDate)) {
    store.dispatch(setFilterPickupDate(''));
    return;
  }
  store.dispatch(setFilterPickupDate(stringifyFilterDate(pickupDate)));
}

export const setPickupTime = (pickupTime: FilterDates['pickupTime']) => {
  store.dispatch(setFilterPickupTime(pickupTime));
}

export const setReturnDate = (returnDate: FilterDates['returnDate']) => {
  if (!returnDate || isDateBeforeToday(returnDate)) {
    store.dispatch(setFilterReturnDate(''));
    return;
  }
  store.dispatch(setFilterReturnDate(returnDate));
}

export const setRetunTime = (returnTime: FilterDates['returnTime']) => {
  store.dispatch(setFilterReturnTime(returnTime));
}

export const setFilterDates = ({ pickupDate = '', returnDate = '', ...rest }: FilterDates) => {
  store.dispatch(
    setFilterDate({
      pickupDate: stringifyFilterDate(pickupDate),
      returnDate: stringifyFilterDate(returnDate),
      ...rest,
    })
  );
};
